import { render, staticRenderFns } from "./EqifyRulePersonHasIndividualCombinations.vue?vue&type=template&id=61df6743&scoped=true"
import script from "./EqifyRulePersonHasIndividualCombinations.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonHasIndividualCombinations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df6743",
  null
  
)

export default component.exports